import Vue from "vue";
import moment from "moment";

const mutation = {
  UPDATE_MATERIAL_MEDIA_OBJECT_DATA(state, { index, selectedMedia }) {
    if (index !== -1) {
      state.MaterialMediaObject.splice(index, 1, selectedMedia);
    } else {
      state.MaterialMediaObject.push(selectedMedia);
    }
  },

  UPDATE_MEDIA_SELECTED(state, mediaSelected) {
    state.mediaSelected = mediaSelected;
  },

  setErrorLogs(state, payload) {
    state.errorLogs.push(payload);
  },

  setClearErrorLogs(state, payload) {
    state.errorLogs = [];
  },

  setClassRoomKey(state, payload) {
    state.classRoomKey = payload;
  },
  setLiveChats(state, payload) {
    state.liveChats = payload;
  },
  setOnlineUsers(state, payload) {
    state.onlineUsers = payload;
  },
  setHiTutorToken(state, payload) {
    state.HiTutorToken = payload;
  },
  setClassRoomId(state, payload) {
    state.classRoomId = payload;
  },
  setRoom(state, payload) {
    state.room = payload;
  },
  setConnected(state, payload) {
    state.connected = payload;
  },
  setMaterialMediaObject(state, payload) {
    state.MaterialMediaObject = payload;
  },
  setMaterialVedioObject(state, payload) {
    state.MaterialVedioObject = payload;
  },
  setMaterialObject(state, payload) {
    state.MaterialObject = payload;
  },
  setMaterialObjectFrom3000(state, payload) {
    state.MaterialObjectFrom3000 = payload;
  },
  setClassroomMaterial(state, payload) {
    state.ClassroomMaterial = payload;
  },
  setTeacherState(state, payload) {
    state.teacher = payload;
  },
  setTeacherName(state, payload) {
    state.TeacherName = payload;
  },
  setUserId(state, payload) {
    state.UserId = payload;
  },
  setUserName(state, payload) {
    state.UserName = payload;
  },
  setUserType(state, payload) {
    state.UserType = payload;
  },
  setFabricsData(state, payload) {
    state.fabricsData = payload;
  },
  addLiveChat(state, liveChat) {
    state.liveChats.push(liveChat);
  },
  setDynamicCounterMediaFileUrl(state, param) {
    state.setDynamicCounterMediaFileUrl = param;
  },
  setDataGetMaterialByFileUrl(state, param) {
    state.setDataGetMaterialByFileUrl = param;
  },
  setcurrentUserCasalomaRegistered(state, param) {
    state.currentUserCasalomaRegistered = param;
  },
  setcurrentUserCasalomaAccessToken(state, param) {
    state.currentUserCasalomaAccessToken = param;
  },
  setcurrentResponseIMCasaloma(state, param) {
    state.currentResponseIMCasaloma = param;
  },
  setcheckCasalomaRoomNameAvailability(state, param) {
    state.checkCasalomaRoomNameAvailability = param;
  },
  setcasalomaRoomName(state, param) {
    state.casalomaRoomName = param;
  },
  setUser(state, { user, jwtToken }) {
    state.user = user;
    state.jwtToken = state.jwtToken || jwtToken;
    state.isLoggedIn = true;
  },
  setCurrentlyViewingClass(state, payload) {
    state.currentlyViewingClass = payload;
  },

  setIMCasalomaClassAvailability(state, payload) {
    state.IMCasalomaClassAvailability = payload;
  },
  setIMCasalomaUserAvailability(state, payload) {
    state.IMCasalomaUserAvailability = payload;
  },
  setIMCasalomaUserLogin(state, payload) {
    state.IMCasalomaUserLogin = payload;
  },
  setIMCasalomaUserRegister(state, payload) {
    state.IMCasalomaUserRegister = payload;
  },
  setIMCasalomaUserClass(state, payload) {
    state.IMCasalomaUserClass = payload;
  },
  setIMCasalomaFetchChats(state, payload) {
    state.IMCasalomaFetchChats = payload;
  },
  setClassTime(state, payload) {
    state.classTime = payload;
  },
  setHituteIdentifier(state, payload) {
    state.hituteIdentifier = payload;
  },
  setBeginTimeStamp(state, payload) {
    state.BeginTimeStamp = payload;
  },
  setEndTimeStamp(state, payload) {
    state.EndTimeStamp = payload;
  },

  setCheckInState(state, payload) {
    state.checkInState = payload;
  },

  setCheckOutState(state, payload) {
    state.checkOutState = payload;
  },

  setLessonRecordUrlStore(state, payload) {
    state.LessonRecordUrlStore = payload;
  },

  setTBUrlStore(state, payload) {
    state.TBUrlStore = payload;
  },
  setLessonRecordQuery(state, payload) {
    state.LessonRecordQuery = payload;
  },
  setClassroomMessage(state, payload) {
    state.ClassroomMessage = payload;
  },
  setLiveChatChannel(state, payload) {
    state.LiveChatChannel = payload;
  },
  setAgoraToken(state, payload) {
    state.AgoraToken = payload;
  },
  setAgoraChannel(state, payload) {
    state.setAgoraChannel = payload;
  },
  setAgoraUid(state, payload) {
    state.setAgoraUid = payload;
  },
  addClassroomMessage(state, payload) {
    state.ClassroomMessage.push({
      Content: "",
      FileName:
        payload.Content.FileName == null ? null : payload.Content.FileName,
      FileUrl: payload.Content.FileUrl == null ? null : payload.Content.FileUrl,
      IsMySelf: this.state.UserId == payload.Sender ? true : false,
      Message: payload.Content.Message == null ? "" : payload.Content.Message,
      SendTime: moment(payload.SendDateTime).format("YYYY-MM-DD HH:mm:ss"),
      UserId: payload.Sender,
      UserName: payload.SenderName,
      messageType: payload.MessageType,
    });
  },

  //TEACHER
  SET_FULL_STATUS_TEACHER(store, teacher_full_status) {
    store.teacher_full_status = teacher_full_status;
  },
  SET_PERMISSIONS_TEACHER(store, teacher_permissions) {
    store.teacher_permissions = teacher_permissions;
  },
  SET_STUDENTMIKESTATUS_TEACHER(store, teacher_studentMikeStatus) {
    store.teacher_studentMikeStatus = teacher_studentMikeStatus;
  },
  SET_STUDENTCAMERASTATUS_TEACHER(store, teacher_studentCameraStatus) {
    store.teacher_studentCameraStatus = teacher_studentCameraStatus;
  },

  //STUDENT
  SET_FULL_STATUS_STUDENT(store, student_full_status) {
    store.student_full_status = student_full_status;
  },
  SET_PERMISSIONS_STUDENT(store, student_permissions) {
    store.student_permissions = student_permissions;
  },
  SET_DRAWING_PERMISSIONS_STUDENT(store, student_drawing_permissions) {
    store.student_drawing_permissions = student_drawing_permissions;
  },
  SET_TEACHERMIKESTATUS_STUDENT(store, student_teacherMikeStatus) {
    store.student_teacherMikeStatus = student_teacherMikeStatus;
  },
  SET_TEACHERCAMERASTATUS_STUDENT(store, student_teacherCameraStatus) {
    store.student_teacherCameraStatus = student_teacherCameraStatus;
  },

  //EMPLOYEE
  SET_FULL_STATUS_EMPLOYEE(store, employee_full_status) {
    store.employee_full_status = employee_full_status;
  },
  SET_PERMISSIONS_EMPLOYEE(store, employee_permissions) {
    store.employee_permissions = employee_permissions;
  },
  SET_CAMERA_STATUS_EMPLOYEE(store, employee_camera_status) {
    store.employee_camera_status = employee_camera_status;
  },

  SET_TEACHERMIKESTATUS_EMPLOYEE(store, employee_teacherMikeStatus) {
    store.employee_teacherMikeStatus = employee_teacherMikeStatus;
  },
  SET_TEACHERCAMERASTATUS_EMPLOYEE(store, employee_teacherCameraStatus) {
    store.employee_teacherCameraStatus = employee_teacherCameraStatus;
  },
  SET_STUDENTMIKESTATUS_EMPLOYEE(store, employee_studentMikeStatus) {
    store.employee_studentMikeStatus = employee_studentMikeStatus;
  },
  SET_STUDENTCAMERASTATUS_EMPLOYEE(store, employee_studentCameraStatus) {
    store.employee_studentCameraStatus = employee_studentCameraStatus;
  },

  //OBSERVER
  SET_FULL_STATUS_OBSERVATION(store, observation_full_status) {
    store.observation_full_status = observation_full_status;
  },
  SET_PERMISSIONS_OBSERVATION(store, observation_permissions) {
    store.observation_permissions = observation_permissions;
  },
  SET_TEACHERMIKESTATUS_OBSERVATION(store, observation_teacherMikeStatus) {
    store.observation_teacherMikeStatus = observation_teacherMikeStatus;
  },
  SET_TEACHERCAMERASTATUS_OBSERVATION(store, observation_teacherCameraStatus) {
    store.observation_teacherCameraStatus = observation_teacherCameraStatus;
  },
  SET_STUDENTMIKESTATUS_OBSERVATION(store, observation_studentMikeStatus) {
    store.observation_studentMikeStatus = observation_studentMikeStatus;
  },
  SET_STUDENTCAMERASTATUS_OBSERVATION(store, observation_studentCameraStatus) {
    store.observation_studentCameraStatus = observation_studentCameraStatus;
  },

  SET_TEACHERSTART_CLASS(store, teacher_start_class) {
    store.teacher_start_class = teacher_start_class;
  },
};

export default mutation;
